import PageHero from "../components/PageHero";

const events = [
  {
    title: "She4Sea Multiplier Event at the Posidonia Sea Tourism Forum – Heraklion, Greece",
    description:
      "On May 7, 2025, the She4Sea workshop was hosted as a parallel session of the 8th Posidonia Sea Tourism Forum in Heraklion, Crete. Organized by HELMEPA, the session attracted over 100 participants, including professionals from the maritime and cruise industries, policymakers, local business leaders, students, and representatives of all international She4Sea partners.",
    images: [
      "/images/news/she4sea/events/el_event1.jpg",
      "/images/news/she4sea/events/el_event4.jpg",
    ],
    readMore: "https://she4seaproject.eu/multiplier-events/",
  },
  {
    title: "She4Sea Dissemination Event at Barcelona Nautical School – Spain",
    description:
      "On April 28, 2025, the Barcelona Nautical School hosted the national She4Sea event in Spain, gathering over 30 professionals, primarily women, active in the maritime sector. The event was opened by Dean Agustín Martín Mallofré and She4Sea Coordinator Germán de Melo, who emphasized the project’s role in promoting women’s employability and inclusion in the blue economy.",
    images: [
      "/images/news/she4sea/events/es_event2.jpg",
      "/images/news/she4sea/events/es_event3.jpg",
      "/images/news/she4sea/events/es_event4.jpg",
    ],
    readMore: "https://she4seaproject.eu/multiplier-events/",
  },
  {
    title: "She4Sea Event at Nikola Vaptsarov Naval Academy – Varna, Bulgaria",
    description:
      "On April 25, 2025, Nikola Vaptsarov Naval Academy in Varna hosted Bulgaria’s national She4Sea event, bringing together over 40 participants, including students, educators, and maritime professionals committed to gender equality in the sector.",
    images: [
      "/images/news/she4sea/events/bg_event1.jpg",
      "/images/news/she4sea/events/bg_event2.jpg",
    ],
    readMore: "https://she4seaproject.eu/multiplier-events/",
  },
  {
    title: "Project Piloting",
    description:
      "The She4Sea Training Platform piloting phase brought together 99 participants from Greece, Bulgaria and Spain, reaching women aspiring to enter or already working in blue economy sectors. With a satisfaction rate of 96.5%, the piloting confirmed the platform’s relevance, clarity and practical value, while also creating meaningful spaces for networking, feedback and stakeholder engagement. Participants explored training content on leadership, sustainability and entrepreneurship, strengthening local connections with women, educators, career counselors and maritime employment networks.",
    images: [
      "/images/news/she4sea/events/piloting_1.jpg",
      "/images/news/she4sea/events/piloting_2.jpg",
      "/images/news/she4sea/events/piloting_3.jpg",
      "/images/news/she4sea/events/piloting_4.jpg",
    ],
    readMore: "https://she4seaproject.eu/news/",
  },
];

function She4SeaMultiplierEvents() {
  return (
    <>
      <PageHero
        eyebrow="She4Sea"
        title="Multiplier Events & Piloting"
        text="A collection of dissemination events, national activities and piloting sessions carried out within the European project She4Sea."
      />

      <section className="section event-detail-section">
        <div className="event-list">
          {events.map((event) => (
            <article className="event-block" key={event.title}>
              <div className="event-copy">
                <span className="eyebrow">She4Sea Activity</span>
                <h2>{event.title}</h2>
                <p>{event.description}</p>

                <a
                  href={event.readMore}
                  target="_blank"
                  rel="noreferrer"
                  className="btn primary"
                >
                  Read more
                </a>
              </div>

              <div className={`event-gallery gallery-${event.images.length}`}>
                {event.images.map((image) => (
                  <img src={image} alt={event.title} key={image} />
                ))}
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}

export default She4SeaMultiplierEvents;